import { mapColor } from '@bubble-ui/particle-icon-colors';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
export default (function (_ref) {
  var designVersion = _ref.designVersion,
      color = _ref.color,
      colorToken = _ref.colorToken,
      colorTokenArgs = _ref.colorTokenArgs;
  var designContext = useDesignContext(defaultColorVariables);
  return {
    pathStyle: {
      fill: colorToken ? designContext.get(colorToken, colorTokenArgs).toRGBA() : mapColor(color, color || designContext.get('colors/text/default').toRGBA(), designVersion),
      style: {
        transition: 'fill .2s ease'
      }
    }
  };
});
//# sourceMappingURL=icon.js.map